export const createLogoAnimationConfig = (nthOption) => (isAnimatingNthLogo) => (setIsAnimatingNthLogo) => ({
  from: { x: isAnimatingNthLogo === nthOption ? 1 : 0 },
  to: { x: isAnimatingNthLogo === nthOption ? 0 : 1 },
  immediate: isAnimatingNthLogo !== nthOption,
  config: { friction: 50 },
  onRest: () => setIsAnimatingNthLogo(false),
});
